var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvg65(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file_download-24px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.3 19.4992C5.8 19.4992 5.375 19.3242 5.025 18.9742C4.675 18.6242 4.5 18.1992 4.5 17.6992V14.9992H6V17.6992C6 17.7659 6.03333 17.8326 6.1 17.8992C6.16667 17.9659 6.23333 17.9992 6.3 17.9992H17.7C17.7667 17.9992 17.8333 17.9659 17.9 17.8992C17.9667 17.8326 18 17.7659 18 17.6992V14.9992H19.5V17.6992C19.5 18.1992 19.325 18.6242 18.975 18.9742C18.625 19.3242 18.2 19.4992 17.7 19.4992H6.3ZM12 15.6242L7.725 11.3492L8.775 10.2492L11.25 12.7242V4.32422H12.75V12.7242L15.225 10.2492L16.275 11.3492L12 15.6242Z",
    fill: "#FFCD47"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg65);
export default __webpack_public_path__ + "static/media/svg65.2a504676e226b7c62937e8dd9ab930a1.svg";
export { ForwardRef as ReactComponent };